import axios from 'axios'

// 确保携带 session cookie 用于后端登录校验
axios.defaults.withCredentials = true

export function submitVote (data) {
  return axios.post('/vote/submit', data)
}

export function checkVoted () {
  return axios.get('/vote/check')
}

export function getCandidates () {
  return axios.get('/vote/candidates')
}

export function getActivityInfo () {
  return axios.get('/vote/activity')
}

export function getStatistics (activityId) {
  return axios.get('/vote/statistics/' + activityId)
}

export function drawLottery () {
  return axios.post('/lottery/draw')
}

/**
 * 后端抽奖（带工号，用于唯一奖判断）
 * @param {string} employeeId - 员工工号
 */
export function drawLotteryV2 (employeeId) {
  return axios.post('/lottery/draw-v2', { employeeId })
}

export function getLotteryRecord () {
  return axios.get('/lottery/record')
}

/**
 * 保存前端计算的抽奖结果到后端数据库
 * @param {object} data - { level: string|null, amount: number|null }
 */
export function saveLotteryResult (data) {
  return axios.post('/lottery/save-result', data)
}

/**
 * 获取抽奖统计信息（剩余名额、已发金额等）
 */
export function getLotteryStats () {
  return axios.get('/lottery/stats')
}

/**
 * 核销中奖记录
 */
export function claimLotteryPrize () {
  return axios.post('/lottery/claim')
}



// WEBPACK FOOTER //
// ./src/api/vote.js